<script setup>
import { computed, onBeforeUnmount, reactive, ref, watch } from 'vue'
import { authStore } from '@/stores/auth.js'
import { marketAnalysisApi } from '@/api/index.js'
import { recoveringRead, readState } from '@/api/recoveringRead.js'
import { reportStrategy } from '@/presentation/reportStrategy.js'
import { projectScope } from '@/utils/projectRefresh.js'
import { useProjectRefresh } from '@/composables/useProjectRefresh.js'
const props = defineProps({ latest: Object, projectId: String })
const tenantId = authStore.state.selectedTenant?.id
const body = ref(null), state = reactive(readState())
let reader = null
const excerpts = computed(() => reportStrategy(body.value?.report))
watch(() => props.latest?.report_id, id => {
  reader?.stop()
  body.value = null
  Object.assign(state, readState())
  if (!id) { reader = null; return }
  const projectId = props.projectId
  reader = recoveringRead(signal => marketAnalysisApi.report(tenantId, projectId, id, { signal }),
    value => { body.value = value }, state)
  void reader.run()
}, { immediate: true })
useProjectRefresh(projectScope(tenantId, props.projectId), () => !state.loaded || state.error ? reader?.run() : Promise.resolve())
onBeforeUnmount(() => reader?.stop())
</script>

<template>
  <p v-if="state.error" role="status">报告策略节录暂时无法读取，已保存的报告仍可从原文查看。</p>
  <p v-else-if="!state.loaded" role="status">正在读取已保存的报告策略…</p>
  <template v-else>
    <p class="strategy-notice">以下为报告 v{{ latest.version }} 原文节录，建议及企业自述仍需实际验证。当前资料更新不会改写历史报告。</p>
    <div class="strategy-excerpts"><article v-for="item in excerpts" :key="item.number">
      <h3>{{ item.label }}</h3><small>来源：第 {{ item.number }} 章 {{ item.title }}</small>
      <p>{{ item.text || '该章节没有可直接节录的结论，请查看完整报告。' }}</p>
      <p v-if="item.caveat"><strong>限制与待核验：</strong>{{ item.caveat }}</p>
    </article></div>
  </template>
</template>

<style scoped>
.strategy-excerpts { display: grid; gap: 14px; grid-template-columns: repeat(auto-fit, minmax(220px, 1fr)); }
article { padding: 16px; border: 1px solid #dce6e9; border-radius: 12px; min-width: 0; }
h3 { margin: 0 0 10px; } p { line-height: 1.7; white-space: pre-line; overflow-wrap: anywhere; }
article p { max-height: 220px; overflow: auto; } small, .strategy-notice { color: #536e76; }
</style>
